import styled from 'styled-components';

export const Wrapper = styled.div`
  width: max-content;
  height: 32px;
  border: 1px dashed ${({ theme }) => theme.palette.P500};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  justify-content: center;
  padding: 0px 6px 0px 6px;
`;

export const WrapperContent = styled.div``;

export const WorldLogoLabel = styled.span`
  display: block;
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.P500};
`;
